<template>
  <v-form ref="form" v-model="valid">
   <v-dialog v-model="show" max-width="400px" scrollable>    
      <v-card >
        <v-card-title primary-title class="headline">
          Add Subscription
          <v-progress-linear v-if="running" :indeterminate="true"></v-progress-linear>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-lg fluid>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :disabled="running"
                  label="Name"
                  v-model="subName"
                  :rules="[rules.required, rules.minLength(5), rules.maxLength(63)]"
                  autofocus
                ></v-text-field>
              </v-flex>      

              <!-- <v-flex xs12>
                <v-text-field
                  :disabled="running"
                  label="Serial No"
                  v-model="subSn"
                  :rules="[rules.required, rules.minLength(7), rules.maxLength(7), rules.serialNo]"
                ></v-text-field>
              </v-flex>       -->

              <v-flex xs12>
                <v-textarea
                  :disabled="running"
                  label="Description"
                  v-model="subDesc"
                  :rules="[]"
                ></v-textarea>
              </v-flex>      

            </v-layout>
          </v-container>      
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            :disabled="running || !valid"
            color="primary" 
            flat @click.stop="handleOK"
          >OK</v-btn>
          <v-btn 
            color="primary" 
            flat @click.stop="handleClose"
          >Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </v-form>
  
</template>

<script>
import Vue from "vue";
import semver from "semver";
import store from "@/store";
import { Atmos } from "@/apis/atmos";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "dialog-add-subscription",

  data() {
    return {
      subName: null,
      subSn: null,
      subDesc: null,
      running: false,      
      valid: false,

      rules: {
        required: v => !!v || 'Value is required.',
        minLength(len) { return v => (v || '').length >= len || `Value is too short. Must be greater than ${len} characters.` },
        maxLength(len) { return v => (v || '').length <= len || `Value is too long. Must be less than than ${len} characters.` },
        serialNo: v=> /\d{3}-\d{3}/.test(v || '') || 'Invalid serial number format. Value must be in 123-456 format.',
      },
    };
  },

  computed: {
    ...mapGetters('atmos', []),

    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  watch: {
    show: function (val, oldVal) {
      if (val) {
        this.subName = null;
        this.subSn = null;
        this.subDesc = null;
        this.running = false;
        this.$refs.form.reset();
      }
    }
  },

  props: {
    value: Boolean,
  },

  methods: {
    ...mapActions('atmos',
      ["atmosAddSubscription"]),
    
    handleClose() {
      this.show = false;
    },

    async handleOK() {
      this.running = true;
      try {        

        await this.atmosAddSubscription({
          name: this.subName,
          sn: this.subSn,
          desc: this.subDesc,
        });

        this.show = false;        
      } catch (e) {
        alert(e);
      } finally {
        this.running = false;
      }
    },
  }
};
</script>

<style scoped>
</style>